import "./DeliveryWorkflows.css";

import { WorkflowTemplatePanel } from "../../../../../templates";
import { RelatedProjectsPanel, WorkflowDataCards } from "../../../../shared/workflows/workflow-templates/components";
import { WorkflowTemplateTypeConstants } from "../constants";
import { useDeliveryWorkflows } from "./useDeliveryWorkflows";

const DeliveryWorkflows = (): JSX.Element => {
  const {
    onPrevious,
    onNext,
    hasNext,
    hasPrevious,
    workflowTemplates,
    isLoadingWorkflowTemplates,
    relatedProjectWorkflowTemplateUuid,

    projectTypeFilterUuid,
    setProjectTypeFilterUuid,

    showCreateWorkflowTemplatePanel,
    setShowCreateWorkflowTemplatePanel,
    isExpiredFilter,
    setIsExpiredFilter,

    setRefreshWorkflowTemplates,

    projectTypesSelectData,
  } = useDeliveryWorkflows();

  return (
    <div className="DeliveryWorkflows">
      <WorkflowDataCards
        header="Available workflow templates"
        data={workflowTemplates}
        setShowCreateWorkflowTemplatePanel={setShowCreateWorkflowTemplatePanel}
        projectTypesSelectData={projectTypesSelectData}
        projectTypeFilterUuid={projectTypeFilterUuid}
        setProjectTypeFilterUuid={setProjectTypeFilterUuid}
        onPrevious={onPrevious}
        onNext={onNext}
        hasNext={hasNext}
        hasPrevious={hasPrevious}
        isLoadingWorkflowTemplates={isLoadingWorkflowTemplates}
        workflowTemplateUuid={relatedProjectWorkflowTemplateUuid}
        isExpiredFilter={isExpiredFilter}
        setIsExpiredFilter={setIsExpiredFilter}
      />
      <RelatedProjectsPanel workflowTemplateUuid={relatedProjectWorkflowTemplateUuid} />
      <WorkflowTemplatePanel
        workflowTemplateType={WorkflowTemplateTypeConstants.PROJECT}
        projectTypesSelectData={projectTypesSelectData}
        show={showCreateWorkflowTemplatePanel}
        onClose={() => setShowCreateWorkflowTemplatePanel(false)}
        setRefresh={setRefreshWorkflowTemplates}
      />
    </div>
  );
};

export default DeliveryWorkflows;
